import moment from 'moment';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import Text from 'shell/components/Text';

export default forwardRef((props, ref) => {
    const { t } = useTranslation();

    return (
        <Text ref={ref} {...props} color={'light'} variant={'p3'}>
            {t('ui.copyright-tg', '© Copyright TimelyGrader {{year}}', { year: moment().format('YYYY') })}
        </Text>
    );
});
